<template>
    <div>
        <v-form ref="marriage_ack_form" v-model="marriageAckFormValidity">
            <v-layout row wrap>
                <v-flex xs12>
                    <h5>Applicants acknowledge the following requirements for a marriage license application:</h5>
                </v-flex>
                <v-flex xs12>
                    <div v-for="ack in ackList" :key="ack.id">
                        <v-checkbox
                            v-model="selectedAck"
                            :value="ack.id"
                            :label="ack.name"
                            :disabled="!canEdit"
                            :rules="validateCheckbox"
                            v-on:click="emitCheckChange"
                        />
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>

import marriageWsService from '@/services/marriageWorksheetService'

export default {
    name: 'marriage-ws-ack',
    props: {
        canEdit: Boolean,
        selectedAckProp: Array
    },
    data: () => {
        return {
            marriageAckFormValidity: false,
            selectedAck: [],
            ackList: [
                { id: 1, name: 'Both applicants must appear in person to the County Clerk, and present a photo ID.' },
                {
                    id: 2,
                    name:
                        'Both applicants must know their full legal names, current residence, date of birth, state of birth and Social Security number.'
                },
                {
                    id: 3,
                    name: "Both applicants must know their parents' names, birthplaces, and mother's maiden name"
                },
                { id: 4, name: 'Provide divorce or death certificate, as applicable to previous marriages.' },
                {
                    id: 5,
                    name:
                        'Applicants must be 18 years of age or older, or meet the requirement for the rights to contract under W.S. 14-1-102 or has received a declaration of emancipation pursuant to W.S. 14-1-203. Applicants that are 16 or 17 must have written consent of guardian and a competent witness, and court order. Applicants that are 17 and have written consent of guardian and a competent witness may be issued a license if they are waiting until both parties are aged 18 to exercise the license. No person shall marry who is under the age of sixteen (16) years.'
                },
                {
                    id: 6,
                    name:
                        ' Marriage License fee $30.00, payable to issuing County Clerk office at the time of license issuance.'
                }
            ]
        }
    },
    computed: {
        validateCheckbox () {
            return [this.selectedAck.length > 0 || 'Required']
        }
    },
    methods: {
        validate () {
            var valid = this.$refs.marriage_ack_form.validate()
            return valid
        },
        saveAck (marriageWorksheetId) {
            return marriageWsService.saveAcks(this.$http, marriageWorksheetId, this.selectedAck)
        },
        emitCheckChange () {
            //this.$emit('on-check', true)
        }
    },
    watch: {
        selectedAckProp: {
            handler (value) {
                this.selectedAck = value
            }
        }
    }
}
</script>

<style>
h5 {
    font-weight: 500 !important;
}</style
>>
